// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle-wrapper[data-v-0b252623]{display:block;color:#003653;font-weight:600;font-size:15px;border-width:2px;border-top:0;border-left:0;border-right:0;padding-bottom:8px}", ""]);
// Exports
module.exports = exports;
